module.exports = __webpack_public_path__ + "b8b6a42a6efd77af288341d7523f16d0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/uneven-24.png
// module id = 2228
// module chunks = 0